import { render, staticRenderFns } from "./sale_rtn.vue?vue&type=template&id=6827f494&scoped=true"
import script from "./sale_rtn.vue?vue&type=script&lang=js"
export * from "./sale_rtn.vue?vue&type=script&lang=js"
import style0 from "./sale_rtn.vue?vue&type=style&index=0&id=6827f494&prod&scoped=true&lang=less"
import style1 from "./sale_rtn.vue?vue&type=style&index=1&id=6827f494&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827f494",
  null
  
)

export default component.exports